import { useStore } from '@/store';
import { useSetupStore } from '../../store';
import { useEffect, useState } from 'react';
import { getOrders } from '@/api';
import { DirtyType } from '@/types';

export const useUpdateOrderGet = () => {
  const [setTextContent, setSyncTextContent, setStoreFile, setStoreFiles] =
    useStore(({ config: c }) => [
      c.setTextContent,
      c.setSyncTextContent,
      c.setFile,
      c.setFiles,
    ]);
  const addDirtyAll = useStore(({ entries: e }) => e.addDirtyAll);

  const [step, setCurrentStep] = useSetupStore((s) => [
    s.currentStep,
    s.setCurrentStep,
  ]);

  const [bookingNumber, setBookingNumber] = useState('');
  const [correctFound, setCorrectFound] = useState<boolean | null>(null);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (!bookingNumber) {
        setCorrectFound(null);
        return;
      }
      getOrders(bookingNumber)
        .then((response) => {
          if (response?.order) {
            const orderText = JSON.stringify(response.order);
            const orderFile = new File([orderText], `${bookingNumber}.json`, {
              type: 'application/json',
            });
            const orderSyncText = JSON.stringify(response.sync);
            const orderSyncFile = new File(
              [orderSyncText],
              `${bookingNumber}-sync.json`,
            );
            setStoreFile(orderFile);
            setStoreFiles([orderFile, orderSyncFile]);
            setTextContent(orderText);
            setSyncTextContent(orderSyncText);
            addDirtyAll(DirtyType.Template);
            setCorrectFound(true);
          } else {
            setCorrectFound(false);
          }
        })
        .catch((error) => {
          setCorrectFound(false);
        });
    }, 500);

    return () => clearTimeout(timeout);
  }, [bookingNumber]);

  const progressSetup = () => {
    setCurrentStep(step + 1);
  };

  return {
    progressSetup,
    disableNext: correctFound !== true,
    correctFound,
    bookingNumber,
    setBookingNumber,
  };
};
